import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseService } from 'src/app/core/services/base.service';

@Component({
  selector: 'app-sales-order-ledaine-line-detail-dialog',
  templateUrl: './sales-order-ledaine-line-detail-dialog.component.html',
  styleUrls: ['./sales-order-ledaine-line-detail-dialog.component.scss']
})
export class SalesOrderLedaineLineDetailDialogComponent implements OnInit {
  details: {
    ledaineOrderId: number;
    ledaineInvoiceNumber: string;
    ledaineOrderNumber: string;
    ledaineCustomerPoNumber: string;
    orderDate: string;
    totalQty: number;
    totalRsp: number;
    lines: {
      ledaineOrderLineId: number;
      ledaineOrderId: number;
      lineSequence: number;
      productCode: string;
      productDesc: string;
      orderQty: number;
      lineRsp: number;
    }[];
  } = null;;
  error: string = null;
  loading: boolean = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      stockCode: string;
      storeId: number;
      salesOrderHeaderId: number;
      salesOrderNumber: string;
      lineNumber: number;
    },
    private baseService: BaseService,
  ) { }

  ngOnInit(): void {
    this.baseService.executeCommand<any>('portal_sales_order_non_stock_code_details', { stockCode: this.data.stockCode, salesOrderHeaderId: this.data.salesOrderHeaderId, salesOrderNumber: this.data.salesOrderNumber, salesOrderLine: this.data.lineNumber })
      .subscribe(
        response => {
          if (response.responseCode === 0) {
            this.details = response.data;
            this.error = response.data.error;
          }
          this.loading = false;
        },
      error => {
        this.loading = false;
      });
  }
}
